import React from "react"

import {
  RepRow,
  SlideRow,
  VideoCol,
} from "../../styles/Components/VideoTestimonial/VideoSlideStyles"
import Img from "../../utils/OptimizedImage"

import ImageVideo from "./ImageVideo"

const VideoSlide = ({ testimonialObject }) => {
  const rep = testimonialObject?.rep
  const icon = testimonialObject?.icon
  const image = testimonialObject?.image
  const video = testimonialObject?.video
  const mediaType = testimonialObject?.mediaType
  const company = testimonialObject?.companyName
  const testimonial = testimonialObject?.testimonialQuote

  return (
    <SlideRow>
      <div className="testimonial-section">
        {icon?.gatsbyImageData ? (
          <Img
            width={64}
            height={64}
            image={icon?.gatsbyImageData}
            alt="Testimonial"
          />
        ) : (
          icon?.url && (
            <Img width={64} height={64} src={icon?.url} alt="Testimonial" />
          )
        )}
        {testimonial && (
          <p className="testimonial-text">&quot;{testimonial}&quot;</p>
        )}
        {rep && company && (
          <RepRow>
            <bold className="bold-rep">{rep}</bold>
            <small className="company-name-thin">
              {","}&nbsp;{company}
            </small>
          </RepRow>
        )}
      </div>
      <VideoCol className="video-section">
        <ImageVideo image={image} video={video} mediaType={mediaType} />
      </VideoCol>
    </SlideRow>
  )
}

export default VideoSlide
